export const API_BASE_URL = "https://localhost:5001";
export const ALERT_TIME = 2500;